import {
  // Start of Mapping imports
  NodeVideoPage,
  NodeVacancy,
  NodeProject,
  NodeOverviewPage,
  NodeLandingPage,
  NodeCampaignLandingPage,
  NodeCampaignArticleDetail,
  NodeActivity,
  NodeBasicPage,
  NodeArticle,
  NodePartner,
  NodeAnnualReportLandingPage,
  NodeAnnualReportArticle,
  NodeCampaignPageColorTheme,
  NodeRentalLocation,
} from '../implementations';

const mappers = {
  // Start of Mapping entries
  article: NodeArticle,
  video_page: NodeVideoPage,
  vacancy: NodeVacancy,
  project: NodeProject,
  overview_page: NodeOverviewPage,
  landing_page: NodeLandingPage,
  campaign_landing_page: NodeCampaignLandingPage,
  campaign_article: NodeCampaignArticleDetail,
  campaign_page_color: NodeCampaignPageColorTheme,
  basic_page: NodeBasicPage,
  activity: NodeActivity,
  partner: NodePartner,
  annual_report_landing_page: NodeAnnualReportLandingPage,
  annual_report_article: NodeAnnualReportArticle,
  rental_location: NodeRentalLocation,
};

export default mappers;
